
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.733 2.516l-8.239 8.24a2.301 2.301 0 00.341 3.198l6.211 6.21a2.301 2.301 0 003.199.342l8.239-8.24c.375-.385.56-.917.507-1.452l-.43-5.85a2.828 2.828 0 00-2.524-2.526l-5.85-.429a1.823 1.823 0 00-1.454.507zm4.73 6.415c-.37 0-.722-.151-.976-.418a1.346 1.346 0 010-1.95 1.379 1.379 0 011.95 1.95 1.346 1.346 0 01-.975.418z","fill":"#7B01B5"}})])
          )
        }
      }
    